import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const QueryGroupToggle = ({ value, groups, onChange }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={value}
    onChange={(_, next) => {
      if (next) onChange(next);
    }}
    sx={{
      bgcolor: "background.paper",
      "& .MuiToggleButton-root": {
        borderColor: "divider",
        color: "text.secondary",
        fontWeight: 700,
        textTransform: "none",
        px: 1.25,
        lineHeight: 1.2,
      },
      "& .Mui-selected": {
        color: "primary.contrastText",
        bgcolor: "primary.main",
        "&:hover": {
          bgcolor: "primary.dark",
        },
      },
    }}
  >
    {groups.map((group) => (
      <ToggleButton key={group.id} value={group.id}>
        {group.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default QueryGroupToggle;
